import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootStateType } from '../redux-store/reducers';
import { getNextPageGenerator } from '../utils/search';

export type FilterFuntion = (data: any) => boolean;

type SchemeSearchType = {
    recordPerPage?: number;
    filters?: FilterFuntion[];
    page?: number;
    defaultFilterData?: any;
};

type PageInfoType<T, S> = {
    data: T[];
    nextPage?: S | undefined;
};

export function useSchemeSearch({
    filters,
    recordPerPage = 25,
    page = 1,
    defaultFilterData = [],
    ...props
}: SchemeSearchType) {
    const { exploreSchemeData = [] } = useSelector(({ newPurchase }: RootStateType) => ({
        ...newPurchase,
    }));

    const [filterData, setFilterData] = useState<PageInfoType<any[], Generator>>({ data: [] });
    const [searchData, setSearchData] = useState<PageInfoType<any[], Generator>>({ data: [] });
    const splitDataIntoChunks = useCallback((data: any[], numberOfChunks: number = 4) => {
        let chunked = [];
        for (let ele of data) {
            let last = chunked[chunked.length - 1];
            if (!last || last.length === numberOfChunks) {
                chunked.push([ele]);
            } else {
                last.push(ele);
            }
        }
        return chunked;
    }, []);

    const memorizedChunks = useMemo(
        () =>
            splitDataIntoChunks(
                new Array(10)
                    .fill('')
                    .map((_, index) => [...exploreSchemeData])
                    .flat(),
                500,
            ),
        [exploreSchemeData],
    );

    const getValues = useCallback(
        async (_filters: FilterFuntion[] = []) => {
            let _filterFuncs = _filters.length ? _filters : filters;

            const getFunds = getNextPageGenerator({
                itemsPerPage: 15,
                data: exploreSchemeData,
                filters: _filterFuncs,
            });
            const data = getFunds.next().value; // calling data with filters
            setFilterData({ data, nextPage: getFunds });

            // try {
            //     let promises = memorizedChunks.map((chunk, index) => {
            //         return new Promise((resolve, reject) => {
            //             if (!chunk || !chunk.length) {
            //                 resolve([]);
            //             }
            //             let data = chunk.filter((scheme) =>
            //                 _filterFuncs?.every((func: (body: any) => boolean) => func.call({}, scheme)),
            //             );
            //             resolve(data);
            //         }).catch((err) => {
            //             console.log(err);
            //         });
            //     });
            //     let data = await Promise.all(promises);
            //     setFilterData(data.flat());
            // } catch (err: any) {
            //     alert(err.message);
            // }
        },
        [memorizedChunks, filters],
    );

    useEffect(() => {
        getValues();
    }, [getValues]);

    const doGlobalSearch = useCallback(
        (searchKey: string, searchValue: string) => {
            const filterFunc: FilterFuntion = (obj: any) => {
                const value = searchValue?.toLowerCase();
                const targetValue = obj[searchKey]?.toLowerCase();
                return !!searchValue ? targetValue?.includes(value) : true;
            };
            const getFunds = getNextPageGenerator({
                itemsPerPage: 100,
                data: exploreSchemeData,
                filters: [filterFunc],
            });
            setSearchData({ data: getFunds.next().value, nextPage: getFunds });
            getValues([filterFunc]);
        },
        [getValues],
    );

    const resetFilters = useCallback(() => {
        setFilterData(defaultFilterData);
    }, [defaultFilterData]);

    // const memorizedPaginatedData = useMemo(() => {
    //     const paginationData = splitDataIntoChunks(filterData, recordPerPage);
    //     return { totalPages: paginationData.length, data: paginationData[page - 1] || [] };
    // }, [filterData, page, recordPerPage]);

    // return {
    //     exploreData: memorizedPaginatedData.data,
    //     currentPage: page,
    //     totalPages: memorizedPaginatedData.totalPages,
    //     searchData:filterData,
    //     resetFilters,
    //     doGlobalSearch
    // };
    return {
        exploreData: filterData.data,
        nextPage: filterData.nextPage,
        // currentPage: page,
        // totalPages: memorizedPaginatedData.totalPages,
        searchData: searchData.data,
        resetFilters,
        doGlobalSearch,
    };
}
